<template>
  <div class="flex mt-2 flex-row space-x-6 justify-center">
    <Sidebar :menu="{
      'home': {'href': '/', 'title': 'Home'},
      'dash': {'href': '/dashboard', 'title': 'Back to Dashboard'},
      'car': {'href': '/dashboard/career', 'title': 'Career'},
      'mapwise': {'href': '/dashboard/mapwise', 'title': 'Mapwise'},
      'profileCard': {'href': '/profile-card', 'title': 'Profile Card'},
      'spaces': {'href': '/spaces', 'title': 'Spaces'}

    }" v-if="!isHidden"/>
    <div class="flex-none w-3/5 items-start px-3 rounded-box">
      <FullScreenLoader v-if="isLoading"></FullScreenLoader>
      <div class="flex flex-row justify-between md:justify-end space-x-4 mt-6 items-end">
        <a class="md:hidden" @click="isHidden = !isHidden">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24"
               stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16"/>
          </svg>
        </a>
      </div>
      <div class="overflow-x-auto flex-wrap overflow-y-auto w-full mt-6" style="height: 95vh">
        <div class="px-6 py-3 bg-base-200 rounded-box">
          <p class="text-lg leading-10 text-secondary uppercase mb-5 border-b border-base-300">Overview</p>
          <div class="flex flex-wrap flex-col md:flex-row justify-between">
            <div class="shadow stats mb-3 md:mb-0" v-for="(v, k) in getOverview">
              <div class="stat px-8 hover:bg-primary"
                   @mouseover="explanatoryKey = k">
                <div class="stat-title">{{ k }}</div>
                <div class="stat-value">{{ v }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex mt-3 flex-none justify-center">
          <div class="tabs">
            <a class="tab tab-bordered uppercase" v-for="(tab, ind) in tabs" :class="{'tab-active': currentTab === ind}"
               @click="currentTab = ind">{{ tab }}</a>
          </div>
        </div>
        <div class="flex px-4 py-4 justify-center bg-base-200 rounded-box mt-5" v-show="currentTab === 0">
          <keep-alive>
            <Heatmap :point-data="getKillData"></Heatmap>
          </keep-alive>
        </div>
        <div class="flex px-4 py-4 justify-center bg-base-200 rounded-box mt-5" v-show="currentTab === 1">
          <keep-alive>
            <Heatmap :point-data="getDeathData"></Heatmap>
          </keep-alive>
        </div>
        <div class="bg-base-200 rounded-box mt-5" v-show="currentTab === 2">
          <BarChart
              :chart-data="impactBarChart"
              :options="impactBarChartOption"
              :height='200'
              class="px-4 py-4"></BarChart>
        </div>
        <div class="bg-base-200 rounded-box mt-5" v-show="currentTab === 3">
          <BarChart
              :chart-data="damageBarChart"
              :options="damageBarChartOption"
              :height='200'
              class="px-4 py-4"></BarChart>
        </div>

        <div class="bg-base-200 rounded-box mt-5" v-show="currentTab === 4">
          <LineChart
              :chart-data="econChart"
              :options="econChartOption"
              :height='200'
              class="px-4 py-4"></LineChart>
        </div>
        <div class="bg-base-200 rounded-box mt-5" v-show="currentTab === 5">
          <RoundSnippet :mapname="getSnippetData['mapname']"
                        :premium="getSnippetData['premium']"
                        :old-data="getSnippetData['oldData']"
                        :ds-data="getSnippetData['dsData']"
                        :total-rounds="getSnippetData['totalRounds']"
                        :snippet="getSnippetData['snippet']"
          ></RoundSnippet>
        </div>
      </div>
    </div>
    <div class="w-64 text-lg border-l-2 border-base-300 artboard hidden md:block">
      <div class="flex flex-col space-y-2 mt-6 ml-2">
        <div class="bg-base-200 h-48 rounded-box px-2" v-show="currentTab === 0">
          <p class="mt-5">Analyse the points on map where you secured the kill.</p>
        </div>
        <div class="bg-base-200 h-48 rounded-box px-2" v-show="currentTab === 1">
          <p class="mt-5">Analyse the points on map where you were killed. </p>
        </div>
        <div class="bg-base-200 h-48 rounded-box px-2" v-show="currentTab === 2">
          <p class="mt-5">
            This is a dynamic data and aims to help you find your key segments in the match, based on round timer
          </p>
        </div>
        <div class="bg-base-200 h-48 rounded-box px-2" v-show="currentTab === 3">
          <p class="mt-5 text-md">
            Round by Round Damage chart to help you join the dots with your previous analyses
          </p>
        </div>
        <div class="bg-base-200 h-60 rounded-box px-2" v-show="currentTab === 4">
          <p class="mt-5 text-md">
            Assess your economical balance with this chart that consists of the creds you have spent in each round
            with kills and deaths mapped alongside
          </p>
        </div>
        <div class="bg-base-200 h-60 rounded-box px-2" v-show="currentTab === 5">
          <p class="mt-5 text-md">
            Assess each round in detail to analyse your position and your teammates/enemies when you died.
            It aims to help you assess the trade potential
          </p>
        </div>
        <div class="bg-base-200 rounded-box px-2" v-if="explanatoryKey === 'Kills'">
          <p class="uppercase text-secondary px-3 py-3">Insights - Kills</p>
          <RadarChart :chart-data="weaponChart" :options="radarChartOptionSmall" class="mb-3"></RadarChart>
          <button class="btn btn-primary mx-3 mb-4" onclick="location.href ='#modal-chart-kill'">Details</button>
          <button class="btn btn-outline mb-4" @click="explanatoryKey = ''">Close</button>
          <div id="modal-chart-kill" class="modal">
            <div class="modal-box">
              <RadarChart :chart-data="weaponChart" :options="radarChartOptionMedium"/>
              <div class="modal-action">
                <button class="btn" onclick="history.back()">Close</button>
              </div>
            </div>
          </div>
          <div class="text-sm py-4">
            <span class="text-mark">Your average kills are {{ matchDump.hist_kills }}.</span>
            Your kills in this match <span class="text-secondary" v-if="matchDump.kills_comp === true">were higher than your average</span>
            <span class="text-secondary" v-else>were lower than your average</span>
          </div>
        </div>
        <div class="bg-base-200 rounded-box px-2" v-else-if="explanatoryKey === 'Deaths'">
          <p class="uppercase text-secondary px-3 py-3">Insights - Deaths</p>
          <RadarChart :chart-data="deathAgentChart" :options="radarChartOptionSmall" class="mb-3"></RadarChart>
          <button class="btn btn-primary mx-3 mb-4" onclick="location.href ='#modal-chart-death'">Details</button>
          <button class="btn btn-outline mb-4" @click="explanatoryKey = ''">Close</button>
          <div id="modal-chart-death" class="modal">
            <div class="modal-box">
              <RadarChart :chart-data="deathAgentChart" :options="radarChartOptionMedium"/>
              <div class="modal-action">
                <button class="btn" onclick="history.back()">Close</button>
              </div>
            </div>
          </div>
          <div class="text-sm py-4">
            <span class="text-mark">Your average deaths are {{ matchDump.hist_deaths }}.</span>
            Your deaths in this match <span class="text-secondary" v-if="matchDump.deaths_comp === false">were higher than your average</span>
            <span class="text-secondary" v-else>were lower than your average</span>
          </div>
        </div>
        <div class="bg-base-200 rounded-box px-2" v-else-if="explanatoryKey === 'KD'">
          <p class="uppercase text-secondary px-3 py-3">Insights - KD</p>
          <div class="text-sm py-4">
            <span class="text-mark">Your average KD is {{ matchDump.hist_kd }} <br></span>
            Your KD in this match <span class="text-secondary" v-if="matchDump.kd_comp === true">was higher than your average</span>
            <span class="text-secondary" v-else>was lower than your average</span>
          </div>
        </div>
        <div class="bg-base-200 rounded-box px-2" v-else-if="explanatoryKey === 'Damage'">
          <p class="uppercase text-secondary px-3 py-3">Insights - Damage</p>
          <div class="text-sm py-4">
            <span class="text-mark">Your average damage is {{ matchDump.hist_damage }} <br></span>
            Your inflicted damage in this match <span class="text-secondary" v-if="matchDump.damage_comp === true">was higher than your average</span>
            <span class="text-secondary" v-else>was lower than your average</span>
          </div>
        </div>
        <div class="bg-base-200 rounded-box px-2 py-3" v-else-if="explanatoryKey === 'Headshot'">
          <p class="uppercase text-secondary px-3 py-3">Insights - Headshot</p>
          <div class="text-sm py-4">
            <span class="text-mark">Your average headshot is {{ matchDump.hist_hs }}% <br></span>
            Your headshot percentage in this match <span class="text-secondary" v-if="matchDump.hs_comp === true">was higher than your average</span>
            <span class="text-secondary" v-else>was lower than your average</span>
          </div>
          <div class="flex mt-4">
            <svg viewBox="0 0 58 162" style="width: 96px;" class="hitBoxVector">
              <path :fill="valmap(matchDump.legshot_hit)" class="body-legs"
                    d="M44.5745 81.392C44.7603 81.118 45.159 81.2203 45.1962 81.56C46.0544 89.2278 46.3686 95.8726 45.7976 102.675C45.6827 103.548 45.7401 104.388 45.8584 105.214C45.9057 105.546 45.9598 105.871 46.0172 106.2C46.1017 106.689 46.1895 107.179 46.2537 107.668C46.2976 107.994 46.3314 108.322 46.3449 108.651C46.3618 108.98 46.3584 109.312 46.3314 109.645C46.3179 109.813 46.2976 109.977 46.2706 110.149C46.2436 110.317 46.2098 110.485 46.1659 110.657C46.0611 111.555 46.105 112.264 46.2267 112.943C46.2402 113.02 46.2537 113.093 46.2706 113.17C46.3483 113.546 46.4497 113.915 46.5578 114.31C46.5814 114.39 46.6017 114.467 46.6253 114.551C46.6727 114.712 46.72 114.88 46.7673 115.051C46.8652 115.398 46.9632 115.771 47.0612 116.18C47.1085 116.385 47.1558 116.6 47.2031 116.83C47.2268 116.944 47.2504 117.061 47.2707 117.181C47.3382 117.539 47.3991 117.93 47.4565 118.35C47.5308 118.913 47.595 119.537 47.6423 120.235C48.1052 123.976 48.2775 129.901 48.0714 135.764C48.0207 137.211 47.9464 138.65 47.8484 140.057C47.7842 140.995 47.7065 141.912 47.6187 142.807C47.5781 143.228 47.5342 143.64 47.4869 144.049C47.4193 144.641 47.3484 145.218 47.2707 145.777C47.2031 146.077 47.1592 146.406 47.149 146.753C47.1153 148.269 47.7538 150.216 49.852 152.159C50.8217 153.058 51.6325 153.898 52.3488 154.662C52.707 155.045 53.0414 155.407 53.3557 155.747C53.4604 155.86 53.5651 155.973 53.6665 156.079C53.974 156.404 54.2645 156.707 54.5483 156.985C54.8321 157.263 55.1092 157.515 55.3862 157.741C55.6633 157.968 55.8998 158.176 56.0958 158.377C56.2883 158.574 56.4404 158.764 56.5417 158.943C56.6431 159.122 56.6972 159.294 56.6972 159.455C56.6972 159.509 56.6904 159.564 56.6803 159.615C56.6059 159.937 56.312 160.236 55.7579 160.536C55.6802 160.58 55.6059 160.62 55.5315 160.664C55.5079 160.678 55.4876 160.689 55.4673 160.704C55.42 160.733 55.3693 160.762 55.3254 160.792C55.3018 160.806 55.2781 160.821 55.2545 160.835C55.2106 160.865 55.17 160.89 55.1295 160.919C55.1092 160.934 55.0889 160.945 55.0686 160.96C55.0213 160.993 54.974 161.025 54.9301 161.058C54.92 161.066 54.9098 161.073 54.8997 161.08C54.8457 161.12 54.7916 161.161 54.7375 161.197C54.724 161.208 54.7139 161.215 54.7004 161.226C54.6598 161.256 54.6227 161.285 54.5855 161.314C54.5652 161.329 54.5483 161.343 54.5281 161.358C54.4875 161.387 54.4503 161.42 54.4098 161.449C54.3828 161.471 54.3557 161.493 54.3253 161.511C54.3084 161.526 54.2916 161.537 54.2747 161.551C54.2341 161.584 54.1902 161.614 54.153 161.643C54.1496 161.646 54.1463 161.65 54.1395 161.65C54.1057 161.676 54.0686 161.701 54.0348 161.723C54.0213 161.73 54.0077 161.741 53.9976 161.749C53.9706 161.767 53.9469 161.782 53.9199 161.796C53.9064 161.804 53.8895 161.814 53.876 161.822C53.8523 161.836 53.8253 161.851 53.8016 161.862C53.7881 161.869 53.7746 161.877 53.7611 161.884C53.7307 161.898 53.7003 161.909 53.6699 161.924C53.6597 161.928 53.653 161.931 53.6428 161.935C53.6057 161.95 53.5651 161.961 53.5246 161.972C53.5145 161.975 53.5009 161.975 53.4908 161.979C53.4604 161.986 53.4334 161.99 53.403 161.993C53.3894 161.997 53.3726 161.997 53.3557 161.997C53.3286 162.001 53.2982 162.001 53.2712 162.001C53.2577 162.001 53.2408 162.001 53.2273 162.001C53.1732 162.001 53.1192 161.997 53.0583 161.99C53.0482 161.99 53.0381 161.986 53.0313 161.986C52.9773 161.979 52.9232 161.968 52.8691 161.953C52.8556 161.95 52.8421 161.946 52.8252 161.942C52.761 161.924 52.6934 161.902 52.6225 161.877C52.609 161.873 52.5921 161.866 52.5786 161.858C52.5144 161.833 52.4468 161.804 52.3792 161.774C52.3657 161.767 52.3522 161.763 52.3353 161.756C52.2542 161.719 52.1697 161.676 52.0819 161.628C52.0616 161.617 52.0414 161.606 52.0177 161.595C51.9366 161.551 51.8488 161.5 51.7609 161.449C51.7474 161.442 51.7373 161.435 51.7238 161.427C51.6224 161.369 51.5177 161.299 51.4062 161.23C51.3791 161.212 51.3521 161.197 51.3251 161.179C51.2102 161.106 51.0953 161.029 50.9669 160.945C50.9669 160.945 50.9636 160.945 50.9636 160.941C50.4095 160.543 49.8554 160.342 49.2573 159.995C49.1087 159.908 48.9533 159.813 48.7978 159.699C48.6424 159.586 48.4802 159.462 48.3181 159.316C47.9903 159.023 47.6423 158.647 47.2741 158.15C47.0882 157.902 46.9058 157.676 46.72 157.475C45.4327 156.057 44.1826 155.706 43.2129 155.359C42.9358 155.261 42.6824 155.111 42.4628 154.899C42.1892 154.632 41.9695 154.271 41.8243 153.789C41.7398 153.496 41.679 153.164 41.6553 152.78C41.6215 152.269 41.6452 151.67 41.7364 150.972C41.804 150.45 41.8479 149.814 41.8648 149.091C41.8716 148.85 41.8749 148.601 41.8749 148.342C41.8749 147.564 41.8479 146.713 41.7972 145.807C41.7634 145.204 41.7161 144.579 41.6587 143.936C41.5709 142.975 41.4594 141.982 41.3208 140.981C41.1823 139.98 41.0168 138.972 40.8276 137.985C40.7634 137.657 40.6992 137.328 40.6282 137.003C39.1517 128.622 36.1988 128.224 36.9387 121.042C37.2158 118.35 37.3374 116.834 37.3408 115.906C37.3408 115.753 37.3374 115.614 37.334 115.49C37.3273 115.365 37.3205 115.256 37.307 115.154C37.2968 115.055 37.28 114.964 37.2631 114.883C37.236 114.763 37.2056 114.66 37.1685 114.565C37.1076 114.408 37.0299 114.281 36.9387 114.134C36.8306 113.959 36.7056 113.758 36.5671 113.459C36.3812 113.06 36.29 112.461 36.2258 111.731C36.1954 111.365 36.1684 110.967 36.1447 110.547C36.1076 109.915 36.067 109.228 35.9994 108.516C35.9555 108.041 35.8947 107.555 35.817 107.066C35.621 105.842 35.2967 104.603 34.7189 103.482C34.3743 102.81 34.0128 101.966 33.658 101.027C33.4181 100.402 33.1816 99.7303 32.9485 99.0398C32.7728 98.5211 32.6039 97.9914 32.4349 97.4544C32.1579 96.563 31.891 95.6607 31.6477 94.7913C31.4517 94.0935 31.2727 93.4177 31.1071 92.7821C31.0564 92.5812 31.0058 92.3839 30.9585 92.1939C30.8943 91.9309 30.8301 91.6752 30.7726 91.4304C30.7051 91.1491 30.6442 90.8825 30.5868 90.6341C30.5294 90.3856 30.4821 90.1518 30.4381 89.9363C30.374 89.6148 30.3233 88.8147 30.2861 88.5918L30.2827 88.5772C30.1712 87.8576 30.5868 87.1598 31.2423 86.9845C36.1447 86.45 41.2782 84.1718 44.5745 81.392Z"></path>
              <path :fill="valmap(matchDump.legshot_hit)" class="body-legs"
                    d="M14.4864 81.392C14.3006 81.118 13.9019 81.2203 13.8647 81.56C13.0065 89.2278 12.6923 95.8726 13.2633 102.675C13.3782 103.548 13.3208 104.388 13.2025 105.214C13.1552 105.546 13.1011 105.871 13.0437 106.2C12.9592 106.689 12.8714 107.179 12.8072 107.668C12.7633 107.994 12.7295 108.322 12.716 108.651C12.6991 108.98 12.7025 109.312 12.7295 109.645C12.743 109.813 12.7633 109.977 12.7903 110.149C12.8173 110.317 12.8511 110.485 12.8951 110.657C12.9998 111.555 12.9559 112.264 12.8342 112.943C12.8207 113.02 12.8072 113.093 12.7903 113.17C12.7126 113.546 12.6112 113.915 12.5031 114.31C12.4795 114.39 12.4592 114.467 12.4356 114.551C12.3883 114.712 12.3409 114.88 12.2936 115.051C12.1957 115.398 12.0977 115.771 11.9997 116.18C11.9524 116.385 11.9051 116.6 11.8578 116.83C11.8342 116.944 11.8105 117.061 11.7902 117.181C11.7227 117.539 11.6618 117.93 11.6044 118.35C11.5301 118.913 11.4659 119.537 11.4186 120.235C10.9557 123.976 10.7834 129.901 10.9895 135.764C11.0402 137.211 11.1145 138.65 11.2125 140.057C11.2767 140.995 11.3544 141.912 11.4422 142.807C11.4828 143.228 11.5267 143.64 11.574 144.049C11.6416 144.641 11.7125 145.218 11.7902 145.777C11.8578 146.077 11.9017 146.406 11.9119 146.753C11.9456 148.269 11.3071 150.216 9.20892 152.159C8.23925 153.058 7.42837 153.898 6.71209 154.662C6.35395 155.045 6.01946 155.407 5.70524 155.747C5.6005 155.86 5.49576 155.973 5.3944 156.079C5.08695 156.404 4.79638 156.707 4.51257 156.985C4.22876 157.263 3.95171 157.515 3.67466 157.741C3.39761 157.968 3.1611 158.176 2.96514 158.377C2.77256 158.574 2.62052 158.764 2.51916 158.943C2.4178 159.122 2.36374 159.294 2.36374 159.455C2.36374 159.509 2.3705 159.564 2.38063 159.615C2.45497 159.937 2.74891 160.236 3.30301 160.536C3.38072 160.58 3.45505 160.62 3.52938 160.664C3.55304 160.678 3.5733 160.689 3.59358 160.704C3.64088 160.733 3.69156 160.762 3.73548 160.792C3.75913 160.806 3.78278 160.821 3.80643 160.835C3.85035 160.865 3.8909 160.89 3.93144 160.919C3.95171 160.934 3.97199 160.945 3.99226 160.96C4.03956 160.993 4.08686 161.025 4.13079 161.058C4.14092 161.066 4.15106 161.073 4.16119 161.08C4.21525 161.12 4.26931 161.161 4.32337 161.197C4.33688 161.208 4.34702 161.215 4.36053 161.226C4.40108 161.256 4.43824 161.285 4.47541 161.314C4.49568 161.329 4.51257 161.343 4.53284 161.358C4.57339 161.387 4.61056 161.42 4.6511 161.449C4.67813 161.471 4.70516 161.493 4.73557 161.511C4.75246 161.526 4.76935 161.537 4.78624 161.551C4.82679 161.584 4.87071 161.614 4.90788 161.643C4.91126 161.646 4.91464 161.65 4.92139 161.65C4.95518 161.676 4.99234 161.701 5.02613 161.723C5.03965 161.73 5.05316 161.741 5.0633 161.749C5.09033 161.767 5.11398 161.782 5.14101 161.796C5.15452 161.804 5.17142 161.814 5.18493 161.822C5.20858 161.836 5.23561 161.851 5.25926 161.862C5.27277 161.869 5.28629 161.877 5.2998 161.884C5.33021 161.898 5.36062 161.909 5.39103 161.924C5.40116 161.928 5.40792 161.931 5.41806 161.935C5.45522 161.95 5.49576 161.961 5.53631 161.972C5.54644 161.975 5.55996 161.975 5.5701 161.979C5.60051 161.986 5.62753 161.99 5.65794 161.993C5.67146 161.997 5.68835 161.997 5.70524 161.997C5.73227 162.001 5.76268 162.001 5.78971 162.001C5.80322 162.001 5.82012 162.001 5.83363 162.001C5.88769 162.001 5.94175 161.997 6.00257 161.99C6.0127 161.99 6.02284 161.986 6.0296 161.986C6.08365 161.979 6.13771 161.968 6.19177 161.953C6.20528 161.95 6.2188 161.946 6.2357 161.942C6.29989 161.924 6.36747 161.902 6.43842 161.877C6.45193 161.873 6.46882 161.866 6.48234 161.858C6.54653 161.833 6.6141 161.804 6.68168 161.774C6.69519 161.767 6.70871 161.763 6.7256 161.756C6.80669 161.719 6.89116 161.676 6.979 161.628C6.99927 161.617 7.01955 161.606 7.0432 161.595C7.12428 161.551 7.21213 161.5 7.29997 161.449C7.31349 161.442 7.32362 161.435 7.33714 161.427C7.4385 161.369 7.54324 161.299 7.65473 161.23C7.68176 161.212 7.7088 161.197 7.73582 161.179C7.8507 161.106 7.96557 161.029 8.09396 160.945C8.09396 160.945 8.09734 160.945 8.09734 160.941C8.65144 160.543 9.20554 160.342 9.80357 159.995C9.95223 159.908 10.1076 159.813 10.2631 159.699C10.4185 159.586 10.5807 159.462 10.7428 159.316C11.0706 159.023 11.4186 158.647 11.7868 158.15C11.9727 157.902 12.1551 157.676 12.3409 157.475C13.6282 156.057 14.8783 155.706 15.848 155.359C16.1251 155.261 16.3785 155.111 16.5981 154.899C16.8717 154.632 17.0914 154.271 17.2366 153.789C17.3211 153.496 17.3819 153.164 17.4056 152.78C17.4394 152.269 17.4157 151.67 17.3245 150.972C17.2569 150.45 17.213 149.814 17.1961 149.091C17.1893 148.85 17.186 148.601 17.186 148.342C17.186 147.564 17.213 146.713 17.2637 145.807C17.2975 145.204 17.3448 144.579 17.4022 143.936C17.49 142.975 17.6015 141.982 17.7401 140.981C17.8786 139.98 18.0441 138.972 18.2334 137.985C18.2975 137.657 18.3617 137.328 18.4327 137.003C19.9092 128.622 22.8621 128.224 22.1222 121.042C21.8451 118.35 21.7235 116.834 21.7201 115.906C21.7201 115.753 21.7235 115.614 21.7269 115.49C21.7337 115.365 21.7404 115.256 21.7539 115.154C21.7641 115.055 21.781 114.964 21.7978 114.883C21.8249 114.763 21.8553 114.66 21.8924 114.565C21.9533 114.408 22.031 114.281 22.1222 114.134C22.2303 113.959 22.3553 113.758 22.4939 113.459C22.6797 113.06 22.7709 112.461 22.8351 111.731C22.8655 111.365 22.8925 110.967 22.9162 110.547C22.9533 109.915 22.9939 109.228 23.0615 108.516C23.1054 108.041 23.1662 107.555 23.2439 107.066C23.4399 105.842 23.7642 104.603 24.342 103.482C24.6866 102.81 25.0481 101.966 25.4029 101.027C25.6428 100.402 25.8793 99.7303 26.1124 99.0398C26.2881 98.5211 26.457 97.9914 26.626 97.4544C26.903 96.563 27.1699 95.6607 27.4132 94.7913C27.6092 94.0935 27.7882 93.4177 27.9538 92.7821C28.0045 92.5812 28.0551 92.3839 28.1024 92.1939C28.1666 91.9309 28.2308 91.6752 28.2883 91.4304C28.3558 91.1491 28.4167 90.8825 28.4741 90.6341C28.5315 90.3856 28.5788 90.1518 28.6228 89.9363C28.687 89.6148 28.7376 88.8147 28.7748 88.5918L28.7782 88.5772C28.8897 87.8576 28.4741 87.1598 27.8186 86.9845C22.9162 86.45 17.7827 84.1718 14.4864 81.392Z"></path>
              <path :fill="valmap(matchDump.bodyshot_hit)" class="body-torso"
                    d="M10.7407 43.7496C10.328 42.7146 10.115 41.5647 10.115 40.3133C10.115 39.461 10.2299 38.6155 10.4126 37.7835C10.6087 36.8974 10.8827 36.0282 11.2074 35.1793C11.5422 34.3033 11.9312 33.4442 12.3573 32.6088C12.7767 31.7802 13.2333 30.9719 13.7169 30.1771C14.1701 29.433 14.647 28.7059 15.1442 27.9922C15.5196 27.4511 15.9187 26.9269 16.3144 26.4026C16.4159 26.2673 16.2941 26.0746 16.1318 26.1151C15.753 26.2031 15.3809 26.3045 15.0123 26.4229C14.7552 26.5075 14.4982 26.5988 14.2479 26.7002C14.0044 26.7983 13.7338 26.893 13.514 27.0317C13.4734 27.052 13.4328 27.0689 13.3922 27.0892C13.1048 27.2211 12.8139 27.3665 12.5197 27.5255C11.9278 27.8434 11.3258 28.2188 10.7373 28.6585C10.2942 28.9866 9.8613 29.3518 9.44868 29.7543C8.62005 30.5626 7.86922 31.5232 7.28749 32.6663C6.89855 33.4273 6.58401 34.2695 6.37094 35.1962C6.21198 35.8929 6.10713 36.637 6.07331 37.4318C6.07331 40.3877 6.07331 41.8657 4.59532 44.8217C3.11732 47.7777 3.11732 52.2117 3.11732 54.427C3.11732 55.675 2.76558 56.8046 2.39355 58.0154C2.35296 58.1507 2.309 58.286 2.26841 58.4213C2.18386 58.6952 2.10268 58.9725 2.0249 59.26C1.94711 59.5441 1.8727 59.8384 1.80844 60.1394C1.74418 60.4404 1.68668 60.7549 1.63933 61.0762C1.44317 62.4494 1.24701 65.2836 1.16245 68.1381C1.15231 68.473 1.14554 68.8112 1.1354 69.1426C1.12863 69.4774 1.12187 69.8089 1.12187 70.137C1.11848 70.465 1.11848 70.7863 1.11848 71.1043C1.11848 71.2632 1.11848 71.4188 1.12187 71.5744C1.12525 71.8821 1.12863 72.1832 1.13878 72.474C1.14216 72.6194 1.14554 72.7615 1.15231 72.9036C1.16245 73.1843 1.17598 73.4515 1.18951 73.7051C1.21318 74.0873 1.24024 74.439 1.27406 74.7502C1.32141 75.1662 1.34847 75.5822 1.36538 75.9948C1.37214 76.2011 1.37553 76.4074 1.37891 76.6137C1.38229 79.289 0.895264 81.8797 0.895264 83.98C0.895264 84.8695 0.983199 86.1074 1.24701 87.3486C1.36876 87.9135 1.52434 88.4783 1.72727 89.0126C1.88961 89.4388 2.07901 89.848 2.30223 90.2167C2.97189 91.326 3.94257 92.1073 5.32924 92.1073C6.06654 92.1073 6.06654 91.37 5.32924 90.2606C4.59193 89.1513 4.59193 87.3047 4.59193 86.1953C4.59193 85.7793 4.64267 85.4174 4.72722 85.1232C4.83883 84.7342 5.01132 84.4704 5.19057 84.3825C5.23454 84.3588 5.28189 84.3487 5.32924 84.3487C5.44423 84.3487 5.55922 84.5279 5.69789 84.7985C5.73848 84.8797 5.78244 84.9676 5.82979 85.0623C5.87714 85.157 5.92449 85.2585 5.97861 85.3633C6.01243 85.431 6.04963 85.502 6.08684 85.5764C6.16124 85.7184 6.2458 85.8639 6.33373 86.0093C6.3777 86.0803 6.42505 86.1514 6.47578 86.2224C6.67195 86.4997 6.90193 86.7534 7.18265 86.9394C7.27735 87.0037 7.36866 87.0578 7.4566 87.1085C7.47689 87.122 7.49719 87.1322 7.51748 87.1457C7.60541 87.1931 7.68659 87.237 7.76776 87.2742C7.7779 87.2776 7.78467 87.281 7.79481 87.2844C7.86584 87.3148 7.93348 87.3385 7.99774 87.3588C8.01465 87.3622 8.02818 87.3689 8.04509 87.3723C8.11273 87.3892 8.17361 87.3994 8.23111 87.3994C8.24464 87.3994 8.25817 87.396 8.26831 87.396C8.29875 87.3926 8.32919 87.3892 8.35625 87.3825C8.36978 87.3791 8.3833 87.3723 8.39683 87.3689C8.42051 87.3588 8.4408 87.3453 8.46109 87.3283C8.47124 87.3182 8.48139 87.3114 8.49153 87.3013C8.51183 87.281 8.52535 87.2539 8.53888 87.2235C8.54227 87.2134 8.54903 87.2066 8.55579 87.1931C8.5727 87.1491 8.58285 87.1017 8.58623 87.0442C8.58623 87.0307 8.58623 87.0138 8.58623 87.0003C8.58961 86.9529 8.58623 86.9022 8.58285 86.8481C8.57947 86.8244 8.57609 86.794 8.5727 86.7669C8.56594 86.7162 8.55579 86.6587 8.54227 86.6012C8.5355 86.5674 8.52874 86.5369 8.51859 86.5031C8.50168 86.4388 8.48139 86.3678 8.45771 86.2934C8.44757 86.2596 8.43742 86.2258 8.42389 86.1919C8.38669 86.0803 8.34272 85.962 8.29199 85.8301C8.01465 85.1367 7.8929 84.3419 7.75423 83.5573C7.68997 83.192 7.61894 82.8301 7.52424 82.4817C7.48366 82.3329 7.44307 82.1841 7.39234 82.0421C7.14883 81.3284 6.76665 80.7027 6.07331 80.2901C5.37997 79.8775 5.10264 79.147 5.06543 78.3014C5.04176 77.7637 5.11955 77.1752 5.24469 76.5935C5.25821 76.5393 5.26836 76.4818 5.28189 76.4277C5.33939 76.1876 5.40365 75.9509 5.47129 75.7141C5.49158 75.6465 5.51187 75.5788 5.53217 75.5078C5.70466 74.9599 5.89744 74.4424 6.06993 74.0095C6.80723 72.1629 9.76322 64.4042 9.76322 61.0796C9.76322 59.7301 9.70234 58.9252 9.72939 58.3266C9.73278 58.2352 9.73954 58.1473 9.74969 58.0628C9.76321 57.9376 9.78351 57.8192 9.80718 57.7042C9.81733 57.667 9.82747 57.6298 9.83762 57.5893C9.85791 57.5148 9.88497 57.4404 9.91203 57.366C10.0744 56.9568 10.3619 56.5408 10.8726 55.905C10.9199 55.8475 10.9639 55.7866 11.0112 55.7223C11.1025 55.5938 11.1905 55.4517 11.2784 55.2962C11.3663 55.144 11.4509 54.9783 11.5355 54.8058C11.62 54.6333 11.7012 54.4506 11.7823 54.2612C11.9887 53.7742 12.1814 53.2398 12.3573 52.7055C12.7496 51.3898 13.1251 49.7698 10.7407 43.7496Z"></path>
              <path :fill="valmap(matchDump.bodyshot_hit)" class="body-torso"
                    d="M48.1391 43.7496C48.1357 43.7496 48.1357 43.7496 48.1391 43.7496C48.5517 42.7146 48.7648 41.5647 48.7648 40.3133C48.7648 39.461 48.6498 38.6155 48.4672 37.7835C48.271 36.8974 47.9971 36.0282 47.6724 35.1793C47.3376 34.3033 46.9486 33.4442 46.5225 32.6088C46.1031 31.7802 45.6465 30.9719 45.1628 30.1771C44.7096 29.433 44.2328 28.7059 43.7356 27.9922C43.3602 27.4511 42.9611 26.9269 42.5654 26.4026C42.4639 26.2673 42.5857 26.0746 42.748 26.1151C43.1268 26.2031 43.4988 26.3045 43.8675 26.4229C44.1245 26.5075 44.3816 26.5988 44.6318 26.7002C44.8754 26.7983 45.1459 26.893 45.3658 27.0317C45.4064 27.052 45.4469 27.0689 45.4875 27.0892C45.775 27.2211 46.0659 27.3665 46.3601 27.5255C46.952 27.8434 47.554 28.2188 48.1425 28.6585C48.5856 28.9866 49.0185 29.3518 49.4311 29.7543C50.2597 30.5626 51.0105 31.5232 51.5923 32.6663C51.9812 33.4273 52.2958 34.2695 52.5088 35.1962C52.6678 35.8929 52.7726 36.637 52.8065 37.4318C52.8065 40.3877 52.8065 41.8657 54.2845 44.8217C55.7624 47.7777 55.7624 52.2117 55.7624 54.427C55.7624 55.675 56.1142 56.8046 56.4862 58.0154C56.5268 58.1507 56.5708 58.286 56.6114 58.4213C56.6959 58.6952 56.7771 58.9726 56.8549 59.26C56.9327 59.5441 57.0071 59.8384 57.0713 60.1394C57.1356 60.4404 57.1931 60.7549 57.2404 61.0762C57.4366 62.4494 57.6328 65.2836 57.7173 68.1381C57.7275 68.473 57.7342 68.8112 57.7444 69.1426C57.7511 69.4775 57.7579 69.8089 57.7579 70.137C57.7613 70.465 57.7613 70.7863 57.7613 71.1043C57.7613 71.2632 57.7613 71.4188 57.7579 71.5744C57.7545 71.8822 57.7511 72.1832 57.741 72.474C57.7376 72.6195 57.7342 72.7615 57.7275 72.9036C57.7173 73.1843 57.7038 73.4515 57.6903 73.7051C57.6666 74.0873 57.6395 74.439 57.6057 74.7502C57.5584 75.1662 57.5313 75.5822 57.5144 75.9948C57.5076 76.2011 57.5042 76.4074 57.5009 76.6138C57.4839 79.2958 57.9744 81.8831 57.9744 83.9834C57.9744 84.8729 57.8864 86.1108 57.6226 87.352C57.5009 87.9168 57.3453 88.4817 57.1424 89.016C56.98 89.4422 56.7906 89.8514 56.5674 90.2201C55.8977 91.3294 54.9271 92.1107 53.5404 92.1107C52.8031 92.1107 52.8031 91.3734 53.5404 90.264C54.2777 89.1547 54.2777 87.3081 54.2777 86.1987C54.2777 85.7827 54.227 85.4208 54.1424 85.1266C54.0308 84.7376 53.8583 84.4738 53.679 84.3859C53.6351 84.3622 53.5877 84.3521 53.5404 84.3521C53.4254 84.3521 53.3104 84.5313 53.1717 84.8019C53.1311 84.8831 53.0872 84.971 53.0398 85.0657C52.9925 85.1604 52.9451 85.2619 52.891 85.3667C52.8572 85.4344 52.82 85.5054 52.7828 85.5798C52.7084 85.7218 52.6238 85.8673 52.5359 86.0127C52.4919 86.0837 52.4446 86.1548 52.3938 86.2258C52.1977 86.5031 51.9677 86.7568 51.687 86.9428C51.5923 87.007 51.501 87.0612 51.413 87.1119C51.3927 87.1254 51.3724 87.1356 51.3521 87.1491C51.2642 87.1965 51.183 87.2404 51.1019 87.2776C51.0917 87.281 51.085 87.2844 51.0748 87.2878C51.0038 87.3182 50.9361 87.3419 50.8719 87.3622C50.855 87.3656 50.8414 87.3723 50.8245 87.3757C50.7569 87.3926 50.696 87.4028 50.6385 87.4028C50.625 87.4028 50.6115 87.3994 50.6013 87.3994C50.5709 87.396 50.5404 87.3926 50.5134 87.3858C50.4998 87.3825 50.4863 87.3757 50.4728 87.3723C50.4491 87.3622 50.4288 87.3486 50.4085 87.3317C50.3984 87.3216 50.3882 87.3148 50.3781 87.3047C50.3578 87.2844 50.3443 87.2573 50.3307 87.2269C50.3274 87.2167 50.3206 87.21 50.3138 87.1964C50.2969 87.1525 50.2868 87.1051 50.2834 87.0476C50.2834 87.0341 50.2834 87.0172 50.2834 87.0037C50.28 86.9563 50.2834 86.9056 50.2868 86.8515C50.2902 86.8278 50.2935 86.7974 50.2969 86.7703C50.3037 86.7196 50.3138 86.6621 50.3274 86.6046C50.3341 86.5708 50.3409 86.5403 50.351 86.5065C50.3679 86.4422 50.3882 86.3712 50.4119 86.2968C50.4221 86.263 50.4322 86.2292 50.4457 86.1953C50.4829 86.0837 50.5269 85.9654 50.5776 85.8334C50.855 85.1401 50.9767 84.3453 51.1154 83.5607C51.1797 83.1954 51.2507 82.8335 51.3454 82.4851C51.386 82.3363 51.4265 82.1875 51.4773 82.0455C51.7208 81.3318 52.103 80.7061 52.7963 80.2935C53.4896 79.8809 53.767 79.1504 53.8042 78.3048C53.8279 77.7671 53.7501 77.1786 53.6249 76.5968C53.6114 76.5427 53.6013 76.4852 53.5877 76.4311C53.5302 76.191 53.466 75.9542 53.3983 75.7175C53.378 75.6498 53.3577 75.5822 53.3375 75.5112C53.165 74.9633 52.9722 74.4458 52.7997 74.0129C52.0624 72.1663 49.1064 64.4076 49.1064 61.083C49.1064 59.7335 49.1673 58.9286 49.1402 58.3299C49.1368 58.2386 49.1301 58.1507 49.1199 58.0661C49.1064 57.941 49.0861 57.8226 49.0624 57.7076C49.0523 57.6704 49.0421 57.6332 49.032 57.5926C49.0117 57.5182 48.9847 57.4438 48.9576 57.3694C48.7953 56.9602 48.5078 56.5442 47.9971 55.9083C47.9497 55.8508 47.9058 55.79 47.8584 55.7257C47.7671 55.5972 47.6791 55.4551 47.5912 55.2996C47.5033 55.1474 47.4187 54.9816 47.3342 54.8091C47.2496 54.6367 47.1684 54.454 47.0873 54.2646C46.881 53.7776 46.6882 53.2432 46.5123 52.7088C46.1267 51.3898 45.7547 49.7698 48.1391 43.7496Z"></path>
              <path :fill="valmap(matchDump.bodyshot_hit)" class="body-torso"
                    d="M44.9065 75.3858C44.8132 74.9077 44.7199 74.4383 44.6197 73.9806C44.2536 72.281 43.8217 70.6747 43.4038 69.182C43.3796 69.1004 43.3588 69.0188 43.3347 68.9371C43.0238 67.8293 42.7198 66.7827 42.4641 65.809C42.3743 65.4737 42.2914 65.1472 42.2154 64.8265C42.1394 64.5088 42.0703 64.1997 42.0081 63.8965C41.9459 63.5963 41.8907 63.3047 41.8492 63.0219C41.7836 62.608 41.7387 62.2115 41.718 61.8383C41.711 61.7042 41.7076 61.573 41.7041 61.4418C41.6972 60.4652 41.8872 59.6518 42.357 59.0134C42.4538 58.8822 42.5505 58.7364 42.6403 58.5819C42.7129 58.4595 42.7889 58.3312 42.8579 58.1971C42.9098 58.0951 42.9616 57.993 43.0134 57.8852C43.1136 57.6723 43.2103 57.4479 43.3036 57.2146C43.4798 56.7744 43.6387 56.3021 43.7838 55.8211C43.7976 55.7686 43.8148 55.7191 43.8287 55.6666C43.8908 55.4596 43.9461 55.2526 44.0048 55.0427C44.0187 54.9961 44.029 54.9494 44.0428 54.9028C44.1396 54.5384 44.2259 54.174 44.3054 53.8183C44.4436 53.2002 44.5576 52.6084 44.6543 52.072C44.7234 50.5036 42.7716 50.2412 39.2652 50.5152C39.1996 50.524 39.1582 50.5269 39.134 50.5269C38.2773 50.626 37.3791 50.6785 36.4395 50.6785H36.3565L36.2736 50.6697C33.7691 50.4161 32.3597 49.836 31.3268 49.4132C30.5288 49.0867 30.1177 48.9293 29.5304 48.9293C28.9432 48.9293 28.5321 49.0867 27.7341 49.4132C26.7046 49.836 25.2917 50.4132 22.7872 50.6697L22.7043 50.6785H22.6214C21.6818 50.6785 20.7836 50.6231 19.9269 50.5269C19.9027 50.5298 19.8612 50.5269 19.7956 50.5152C16.2893 50.2412 14.3375 50.5036 14.4066 52.072C14.5033 52.6084 14.6173 53.2002 14.7555 53.8183C14.8349 54.174 14.9247 54.5413 15.018 54.9028C15.0318 54.9494 15.0422 54.9961 15.056 55.0427C15.1113 55.2526 15.17 55.4596 15.2322 55.6666C15.246 55.7191 15.2633 55.7686 15.2771 55.8211C15.4222 56.3021 15.5811 56.7744 15.7573 57.2146C15.8505 57.4479 15.9473 57.6723 16.0474 57.8852C16.0993 57.993 16.1476 58.0951 16.2029 58.1971C16.272 58.3312 16.3445 58.4595 16.4205 58.5819C16.5138 58.7335 16.6071 58.8793 16.7038 59.0134C17.1771 59.6489 17.3636 60.4652 17.3567 61.4418C17.3567 61.5701 17.3498 61.7042 17.3429 61.8383C17.3222 62.2115 17.2773 62.608 17.2116 63.0219C17.1667 63.3047 17.1114 63.5963 17.0527 63.8965C16.9905 64.1968 16.9214 64.5058 16.8454 64.8265C16.7694 65.1472 16.6865 65.4708 16.5967 65.809C16.3411 66.7827 16.0371 67.8293 15.7262 68.9371C15.702 69.0188 15.6813 69.1004 15.6571 69.182C15.2391 70.6776 14.8073 72.281 14.4411 73.9806C14.3409 74.4383 14.2476 74.9077 14.1544 75.3858C13.9955 76.2167 14.2822 77.0709 14.9489 77.6977C18.0338 80.6013 25.1639 84.1697 29.5339 84.1726C33.9004 84.1726 41.034 80.6013 44.1188 77.6977C44.7787 77.068 45.0654 76.2167 44.9065 75.3858Z"></path>
              <path :fill="valmap(matchDump.bodyshot_hit)" class="body-torso"
                    d="M46.3282 38.1598C46.1016 37.0978 45.7465 36.0629 45.3271 35.0584C44.8908 34.0167 44.3801 33.002 43.8255 32.0178C43.2945 31.0742 42.7195 30.1577 42.1107 29.2614C41.5899 28.4937 41.0454 27.7428 40.4738 27.0089C40.2844 26.7654 40.0916 26.5253 39.8954 26.2851C39.4388 25.7575 38.4682 24.9221 36.3814 25.6865C36.3713 25.6899 36.3611 25.6933 36.3476 25.6966C36.2968 25.7169 36.2461 25.7406 36.192 25.7609C35.0488 26.2107 33.8854 26.6166 32.6949 26.9345C31.6363 27.2186 30.5337 27.4655 29.4311 27.4655C28.3285 27.4655 27.226 27.222 26.1674 26.9345C24.9802 26.6132 23.8168 26.2107 22.6702 25.7609C22.6195 25.7406 22.5688 25.7169 22.5147 25.6966C22.5045 25.6933 22.4944 25.6899 22.4808 25.6865C20.3974 24.9221 19.4234 25.7575 18.9668 26.2851C18.7706 26.5253 18.5779 26.7654 18.3885 27.0089C17.8169 27.7394 17.2723 28.4937 16.7515 29.2614C16.1427 30.1577 15.5678 31.0742 15.0368 32.0178C14.4821 33.002 13.9714 34.0133 13.5351 35.0584C13.1157 36.0595 12.7606 37.0944 12.534 38.1598C12.3818 38.87 12.2871 39.5938 12.2871 40.3176C12.2871 40.6626 12.304 40.994 12.3412 41.3153C12.375 41.6366 12.4291 41.9444 12.4968 42.2386C12.6354 42.8305 12.8384 43.375 13.0988 43.8756C13.2307 44.1259 13.3761 44.3626 13.5351 44.5892C13.7752 44.9308 14.0424 45.2454 14.3434 45.5328C14.543 45.7256 14.7527 45.9083 14.9759 46.0807C15.1991 46.2532 15.4325 46.4122 15.6794 46.561C16.048 46.7842 16.4403 46.9872 16.853 47.163C16.9916 47.2205 17.1303 47.278 17.2724 47.3321C17.6985 47.4945 18.1483 47.6332 18.6151 47.7481C18.9262 47.8259 19.2441 47.8936 19.5688 47.9511C19.8935 48.0086 20.225 48.0559 20.5632 48.0931C21.2396 48.1675 21.9397 48.2047 22.6601 48.2047C26.7051 47.7177 27.3951 46.1755 29.4244 46.1755C31.4536 46.1755 32.1436 47.7177 36.1886 48.2047C36.909 48.2047 37.6091 48.1675 38.2855 48.0931C38.6238 48.0559 38.9552 48.0086 39.2799 47.9511C39.6046 47.8936 39.9225 47.8259 40.2336 47.7481C40.7004 47.6332 41.1468 47.4945 41.5764 47.3321C41.7184 47.278 41.8605 47.2205 41.9957 47.163C42.4084 46.9872 42.8007 46.7842 43.1693 46.561C43.4162 46.4122 43.6496 46.2499 43.8728 46.0807C44.096 45.9083 44.3057 45.7256 44.5053 45.5328C44.8029 45.242 45.0735 44.9274 45.3136 44.5892C45.4726 44.3626 45.618 44.1259 45.7499 43.8756C46.0103 43.375 46.2133 42.8305 46.3519 42.2386C46.4196 41.941 46.4737 41.6332 46.5075 41.3153C46.5413 40.994 46.5616 40.6626 46.5616 40.3176C46.5751 39.5904 46.4804 38.8667 46.3282 38.1598Z"></path>
              <path :fill="valmap(matchDump.headshot_hit)" class="body-head"
                    d="M38.066 11.6751C38.066 11.6684 38.066 11.665 38.066 11.6582C38.0592 11.5838 38.0423 11.5162 38.022 11.4553C38.0186 11.4418 38.0152 11.4282 38.0085 11.4181C37.9848 11.3572 37.9577 11.3031 37.9239 11.2557C37.9172 11.249 37.9104 11.2422 37.9036 11.2321C37.8698 11.1881 37.8292 11.1475 37.7852 11.1171C37.7785 11.1137 37.7751 11.1069 37.7683 11.1035C37.7176 11.0697 37.6635 11.046 37.6026 11.0258C37.5891 11.0224 37.5756 11.019 37.562 11.0156C37.4978 10.9987 37.4301 10.9885 37.3557 10.9885C37.3422 10.9885 37.3287 10.9885 37.3151 10.9919C37.2576 10.9919 37.2001 10.9987 37.1393 11.0088C37.119 11.0122 37.0987 11.0156 37.075 11.019C36.9972 11.0359 36.916 11.0562 36.8281 11.0832C36.8518 11.0156 36.8721 10.9378 36.8924 10.86C36.9329 10.7011 36.9668 10.5218 36.9972 10.3324C37.0141 10.2377 37.0276 10.1396 37.0412 10.0416C37.0682 9.84201 37.0885 9.6357 37.1054 9.42939C37.1156 9.32792 37.1223 9.22308 37.1291 9.12161C37.1426 8.91868 37.1562 8.71914 37.1629 8.53312C37.1934 7.88375 37.1934 7.38996 37.1934 7.38996C37.1934 7.19041 37.1832 6.99087 37.1697 6.79809C37.0479 4.83983 36.3208 3.20288 35.0965 2.0259C34.6365 1.58622 34.1089 1.2108 33.5136 0.906412C33.1855 0.740687 32.8338 0.598637 32.4685 0.476881C32.1709 0.378799 31.8631 0.287481 31.5418 0.219839C31.3017 0.169107 31.0582 0.128521 30.8045 0.0946998C30.5509 0.0608785 30.2938 0.0372035 30.03 0.023675C29.8372 0.0101465 29.6377 0 29.4415 0C29.242 0 29.0458 0.0101465 28.8497 0.023675C28.5858 0.0372035 28.3254 0.0608785 28.0751 0.0946998C27.8215 0.128521 27.578 0.169107 27.3378 0.219839C27.0165 0.287481 26.7088 0.378799 26.4111 0.476881C26.0459 0.598637 25.6941 0.737305 25.3661 0.906412C24.7708 1.2108 24.2432 1.58622 23.7832 2.0259C22.5589 3.20288 21.8317 4.83983 21.71 6.79809C21.6964 6.99425 21.6863 7.19041 21.6863 7.38996C21.6863 7.38996 21.6863 7.88375 21.7167 8.53312C21.7269 8.71914 21.737 8.91868 21.7506 9.12161C21.7573 9.22308 21.7675 9.32454 21.7742 9.42939C21.7911 9.6357 21.8148 9.84201 21.8385 10.0416C21.852 10.1396 21.8656 10.2377 21.8825 10.3324C21.9129 10.5218 21.9467 10.7011 21.9873 10.86C22.0076 10.9412 22.0279 11.0156 22.0516 11.0832C21.9636 11.0528 21.8825 11.0325 21.8047 11.019C21.7844 11.0156 21.7607 11.0122 21.7404 11.0088C21.6795 10.9987 21.6187 10.9919 21.5645 10.9919C21.551 10.9919 21.5375 10.9885 21.524 10.9885C21.4495 10.9885 21.3785 10.9987 21.3176 11.0156C21.3041 11.019 21.2906 11.0224 21.2771 11.0258C21.2162 11.046 21.1587 11.0697 21.1113 11.1035C21.1046 11.1069 21.1012 11.1137 21.0944 11.1171C21.0505 11.1509 21.0099 11.1881 20.9761 11.2321C20.9693 11.2388 20.9625 11.2456 20.9558 11.2557C20.9219 11.3031 20.8949 11.3606 20.8712 11.4181C20.8678 11.4316 20.8611 11.4451 20.8577 11.4553C20.8374 11.5195 20.8205 11.5838 20.8137 11.6582C20.8137 11.6616 20.8137 11.6684 20.8137 11.6751C20.8069 11.7461 20.8069 11.8239 20.8103 11.9017C20.8103 11.9186 20.8103 11.9322 20.8137 11.9491C20.8205 12.0336 20.834 12.1182 20.8509 12.2095C20.8543 12.2264 20.8577 12.2467 20.8644 12.2636C20.8847 12.3583 20.9118 12.4564 20.9456 12.5579C20.9659 12.6187 20.9862 12.6898 21.0031 12.7608C21.0031 12.7676 21.0065 12.7709 21.0065 12.7743C21.0234 12.8453 21.0403 12.9197 21.0572 12.9975C21.0606 13.0077 21.0606 13.0178 21.064 13.0246C21.0809 13.1024 21.0978 13.1836 21.1113 13.2647C21.1147 13.2816 21.1181 13.2985 21.1215 13.3121C21.1384 13.3966 21.1553 13.4812 21.1688 13.5691C21.1857 13.6638 21.206 13.7585 21.2229 13.8532C21.2263 13.8667 21.2263 13.8769 21.2297 13.8904C21.2466 13.9817 21.2669 14.0764 21.2872 14.1711C21.2906 14.1813 21.2906 14.1914 21.294 14.205C21.3143 14.2997 21.3379 14.3944 21.3616 14.4891C21.365 14.4958 21.365 14.506 21.3684 14.5127C21.3921 14.6108 21.4191 14.7055 21.4496 14.8036C21.4496 14.807 21.4495 14.807 21.4529 14.8104C21.4834 14.9084 21.5138 15.0031 21.5476 15.0945V15.0978C21.5815 15.1858 21.6187 15.2737 21.6559 15.3549C21.6592 15.3616 21.6626 15.3684 21.666 15.3752C21.7032 15.453 21.7438 15.5308 21.7878 15.6018C21.7945 15.6119 21.7979 15.6187 21.8047 15.6288C21.8486 15.6965 21.8926 15.7607 21.9433 15.8216C21.9501 15.8318 21.9569 15.8385 21.9636 15.8487C22.0144 15.9062 22.0651 15.9603 22.1226 16.0076C22.1327 16.0144 22.1395 16.0212 22.1497 16.0279C22.2071 16.0753 22.268 16.1125 22.3323 16.1463C22.3424 16.1531 22.3526 16.1564 22.3627 16.1598C22.4304 16.1937 22.498 16.2173 22.5758 16.2376C22.5859 16.241 22.5961 16.241 22.6062 16.2444C22.684 16.2613 22.7652 16.2714 22.8531 16.2714C22.8599 16.2714 22.87 16.2714 22.8768 16.2714C22.9681 16.2714 23.0628 16.2613 23.1643 16.241C23.1643 16.7246 23.1643 17.6344 23.2894 18.5983C23.3165 18.808 23.3571 19.038 23.4078 19.2714C23.6682 20.4348 24.2026 21.5611 24.7674 22.1361C26.3604 23.7629 27.9162 24.977 29.4449 24.977C30.9736 24.977 32.5294 23.7629 34.1224 22.1361C34.6872 21.5577 35.225 20.4315 35.482 19.2714C35.5294 19.038 35.5733 18.808 35.6004 18.5983C35.7255 17.6344 35.7255 16.728 35.7255 16.241C35.827 16.2613 35.9217 16.2714 36.013 16.2714C36.0198 16.2714 36.0299 16.2714 36.0367 16.2714C36.1246 16.2714 36.2058 16.2613 36.2836 16.2444C36.2937 16.241 36.3039 16.241 36.314 16.2376C36.3884 16.2207 36.4594 16.1937 36.5271 16.1598C36.5372 16.1564 36.5474 16.1497 36.5575 16.1463C36.6218 16.1125 36.6827 16.0719 36.7402 16.0279C36.7503 16.0212 36.7571 16.0144 36.7672 16.0076C36.8247 15.9603 36.8755 15.9062 36.9262 15.8487C36.9329 15.8385 36.9397 15.8318 36.9465 15.8216C36.9972 15.7607 37.0412 15.6965 37.0851 15.6288C37.0919 15.6187 37.0953 15.6119 37.1021 15.6018C37.146 15.5308 37.1866 15.4563 37.2238 15.3752C37.2272 15.3684 37.2306 15.3616 37.234 15.3549C37.2712 15.2703 37.3084 15.1858 37.3422 15.0978V15.0945C37.376 15.0031 37.4064 14.9051 37.4369 14.8104C37.4369 14.807 37.4369 14.807 37.4403 14.8036C37.4673 14.7089 37.4944 14.6108 37.5214 14.5127C37.5248 14.506 37.5248 14.4958 37.5282 14.4891C37.5519 14.3944 37.5756 14.2997 37.5958 14.205C37.5992 14.1948 37.5992 14.1847 37.6026 14.1711C37.6229 14.0764 37.6432 13.9851 37.6601 13.8904C37.6635 13.8769 37.6635 13.8667 37.6669 13.8532C37.6872 13.7585 37.7041 13.6604 37.721 13.5691C37.7379 13.4812 37.7548 13.3932 37.7683 13.3121C37.7717 13.2952 37.7751 13.2783 37.7785 13.2647C37.7954 13.1836 37.8089 13.1024 37.8258 13.0246C37.8292 13.0144 37.8292 13.0043 37.8326 12.9975C37.8495 12.9197 37.8664 12.842 37.8833 12.7743C37.8833 12.7676 37.8867 12.7642 37.8867 12.7608C37.907 12.6864 37.9239 12.6187 37.9442 12.5579C37.978 12.4564 38.0051 12.3583 38.0254 12.2636C38.0288 12.2467 38.0355 12.2264 38.0389 12.2095C38.0558 12.1182 38.0693 12.0302 38.0761 11.9491C38.0761 11.9322 38.0761 11.9186 38.0795 11.9017C38.0727 11.8239 38.0727 11.7461 38.066 11.6751Z"></path>
            </svg>
            <div class="flex flex-col justify-between ml-4 mb-6">
              <div>{{matchDump.headshot_hit}}%</div>
              <div>{{matchDump.bodyshot_hit}}%</div>
              <div>{{matchDump.legshot_hit}}%</div>
            </div>
          </div>
        </div>
        <div class="bg-base-200 rounded-box px-2" v-else-if="explanatoryKey === 'Score'">
          <p class="uppercase text-secondary px-3 py-3">Insights - Score</p>
          <div class="text-sm py-4">
            <div class="flex items-center mb-4" v-for="(v, k) in abilityIcon()">
              <img style="max-height: 256px; max-width: 96px; width: 30%; height: 40%;" :src="k"> <span class="text-2xl ml-6">{{ v }}</span>
            </div>
            <span class="text-mark">Your average score is {{ matchDump.hist_score }} <br></span>
            Your score in this match <span class="text-secondary" v-if="matchDump.score_comp === true">was higher than your average</span>
            <span class="text-secondary" v-else>was lower than your average</span>
          </div>
        </div>
        <div class="bg-base-200 py-4 rounded-box px-4" v-else>
          <p class="text-sm">
            Hover on the <span class="text-secondary">overview</span> items to view insights.
            This will be personalized over time for you.
          </p>
          <p class="text-sm mt-3">
            <span class="text-info uppercase">Killmap</span> is your match summary from your kill locations (i.e. where you were when killed the opponent).
          </p>
          <p class="text-sm mt-3">
            <span class="text-info uppercase">Deathmap</span> is your match summary from your death locations (i.e. where you were when you died).
          </p>
          <p class="text-sm mt-3">
            <span class="text-info uppercase">Impact</span> is your match impact spread out between rounds (dynamically).
          </p>
          <p class="text-sm mt-3">
            <span class="text-info uppercase">Damage</span> is your distribution of damage inflicted by you each round.
          </p>
          <p class="text-sm mt-3">
            <span class="text-info uppercase">Econ</span> is your match summary based on your kills, deaths, and economy balance.
          </p>
          <p class="text-sm mt-3">
            <span class="text-info uppercase">Killfeed</span> is in depth round by round analysis to help you read the rounds easily.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div>

  </div>

</template>

<script>
import axios from "axios";
import {useRoute, useRouter} from "vue-router";
import store from "@/store";
import {Chart, registerables} from "chart.js";
import {BarChart, LineChart, RadarChart} from 'vue-chart-3';
import Heatmap from "@/components/Heatmap"
import RoundSnippet from "@/components/RoundSnippet";
import {computed, onMounted, ref} from "vue";
import Sidebar from "@/components/Sidebar";
import OverviewCard from "@/components/OverviewCard";
import FullScreenLoader from "@/components/FullScreenLoader";

Chart.register(...registerables);

export default {
  name: 'Matchwise',
  components: {
    FullScreenLoader,
    OverviewCard,
    Sidebar,
    BarChart,
    LineChart,
    RadarChart,
    Heatmap,
    RoundSnippet
  },
  setup() {
    let matchDump = ref({});
    const route = useRoute();
    const currentTab = ref(0);
    const tabs = ref(['Killmap', 'Deathmap', 'Impact', 'Damage', 'Econ', 'Killfeed']);
    const explanatoryKey = ref('');
    const isPremium = ref(false);
    const isLoading = ref(false);
    const isHidden = ref(false);
    const router = useRouter();

    const fontObj = {
      small: 10,
      medium: 15
    };

    async function initial() {
      let csrf_token = ''
      isLoading.value = true;
      await axios.get('/valorant/csrf-token/')
          .then(response => {
            csrf_token = response.data
          }).catch(
              error => {
                if (error.response.status === 401) {
                  router.push('/login')
                }
              }
          )
      await axios.post(
          '/valorant/matchstats/v1/',
          {
            headers: {'X-CSRFToken': csrf_token},
            'matchid': route.params.matchid, 'puuid': store.state.user.uuid, 'premium': true
          })
          .then(response => {
            matchDump.value = response.data;
          })
          .catch(error => {
            console.log(JSON.stringify(error))
          })
      await axios.get(
          '/account/in/p-checks/'
      ).then(
          response => {
            if (response.data === 'Premium'){
              isPremium.value = true
            }
            isLoading.value = false
          }
      )
    }

    onMounted(() => {
      initial();
      // console.log(isPremium.value, isLoading.value)
    });


    // Utility
    function valmap(val) {
      let ret;
      if (val >= 50 && val < 70) {
        ret = 'rgba(233,69,96,0.5)'
      } else if (val >= 70) {
        ret = 'rgba(233,69,96,0.9)'
      } else {
        ret = 'rgba(233,69,96,0.1)'
      }
      return ret
    }

    function abilityIcon() {
      let abilityCasts = {};
      const agent = matchDump.value.agent;
      for (const [k, v] of Object.entries(matchDump.value.abilitycasts)) {
        const abilityStringMap = {
          'ability1': 'Ability1',
          'ability2': 'Ability2',
          'grenade': 'GrenadeAbility',
          'ult': 'Ultimate',
        }
        abilityCasts[
            `https://brovocado-bucket.s3.eu-west-2.amazonaws.com/assets/agent-abilities/${matchDump.value.agent}/${abilityStringMap[k]}.png`
            ] = v
      }
      return abilityCasts
    }


    // Computed

    const getOverview = computed(() => {
      return {
        Kills: matchDump.value['kills'],
        Deaths: matchDump.value['deaths'],
        KD: matchDump.value['kd'],
        Damage: matchDump.value['damage'],
        Headshot: `${matchDump.value['headshot_hit']}%`,
        Score: matchDump.value['score']
      }
    });

    const damageBarChart = computed(() => {
      return {
        labels: matchDump.value.damageXs,
        datasets: [{
          label: 'Damage',
          data: matchDump.value.damageYs,
          backgroundColor: [
            'rgba(3, 198, 252, 0.2)',
          ],
          borderColor: [
            'rgba(3, 198, 252, 0)',
          ],
          borderWidth: 1,
        }
        ]
      }
    });

    const damageBarChartOption = computed(() => {
      return {
        responsive: true,
        indexAxis: 'x',
        maintainAspectRatio: false,
        scales: {
          yAxes: {
            beginAtZero: true,
            grid: {
              display: false,
            },
            title: {
              display: true,
              text: 'Damage Given'
            },
            drawBorder: false,
            categoryPercentage: 1,
            barPercentage: 0.1,

          },
          xAxes: {
            grid: {
              display: false,
            },
            drawBorder: false,
            categoryPercentage: 1,
            barPercentage: 0.1,
            title: {
              display: true,
              text: 'Rounds',
              font: {
                family: 'Poppins',
                size: 12
              }
            }
          }
        },
      }
    });

    const impactBarChart = computed(() => {
      return {
        labels: ['Early Round', 'Mid Round', 'Late Round'],
        datasets: [
          {
            label: 'Kills',
            data: matchDump.value.killtypes,
            backgroundColor: '#78ccae',
          },
          {
            label: 'Deaths',
            data: matchDump.value.deathtypes,
            backgroundColor: '#E94560',
          }
        ]
      }
    });

    const impactBarChartOption = computed(() => {
      return {
        plugins: {
          tooltip: {
            callbacks: {
              label: function (context) {
                let val = Math.abs(Number(context.formattedValue));
                let label = context.dataset.label;
                return label + ' : ' + String(val);
              }
            }
          }
        },
        scales: {
          xAxes: {
            stacked: true,
            grid: {
              display: false,
            },
          },
          yAxes: {
            stacked: true,
            grid: {
              display: false,
            },
            title: {
              display: true,
              text: 'Kills & Deaths Count'
            },
            ticks: {
              callback: function (value, index, values) {
                return Math.abs(value);
              }
            }
          }
        }
      }
    });

    const econChart = computed(() => {
      return {
        labels: matchDump.value.kdXs,
        datasets: [
          {
            type: 'line',
            label: 'Spent',
            fill: false,
            data: matchDump.value.econ_spent,
            yAxisID: 'y1',
            backgroundColor: [
              'rgba(255, 0, 0, 0.2)',
            ],
            borderColor: [
              'red',
            ],
            borderWidth: 2,
          },
          {
            type: 'bar',
            label: 'Kills',
            fill: true,
            data: matchDump.value.kYs,
            yAxisID: 'y2',
            backgroundColor: [
              '#46EAD0',
            ],
            borderColor: [
              'rgba(3, 198, 252, 0)',
            ],
            borderWidth: 2,
          },
          {
            type: 'bar',
            label: 'Deaths',
            data: matchDump.value.dYs,
            yAxisID: 'y2',
            backgroundColor: [
              '#EA4660',
            ],
            borderColor: [
              'rgba(255, 99, 132, 0)',
            ],
            borderWidth: 2,
          }
        ]
      }
    });

    const econChartOption = computed(() => {
      return {
        responsive: true,
        interaction: {
          mode: 'index',
          intersect: false,
        },
        maintainAspectRatio: false,
        stacked: false,
        scales: {
          y1: {
            type: 'linear',
            display: true,
            position: 'right',
            grid: {
              display: false,
            },
            title: {
              display: true,
              text: 'Credits Spent'
            },
          },
          y2: {
            type: 'linear',
            display: true,
            position: 'left',
            grid: {
              display: false,
              drawOnChartArea: false, // only want the grid lines for one axis to show up
            },
            title: {
              display: true,
              text: 'Kills & Deaths'
            },
          },
          xAxes: {
            grid: {
              display: true,
            },
            drawBorder: false,
            title: {
              display: true,
              text: 'Rounds',
              font: {
                family: 'Poppins',
                size: 12
              }
            }
          }
        },
      }
    });

    const weaponChart = computed(() => {
      return {
        labels: matchDump.value.weapons,
        datasets: [{
          label: 'Kills',
          data: matchDump.value.weapon_kills,
          backgroundColor: [
            'rgba(30, 100, 120, 0.2)',
          ],
          borderColor: [
            'rgba(30, 100, 120, 1)',
          ],
          borderWidth: 1,
          borderRadius: 10,
        }
        ]
      }
    });

    const deathAgentChart = computed(() => {
      return {
        labels: matchDump.value.deathagents,
        datasets: [{
          label: 'Deaths',
          data: matchDump.value.deathcounts,
          backgroundColor: [
            'rgba(30, 100, 120, 0.2)',
          ],
          borderColor: [
            'rgba(30, 100, 120, 1)',
          ],
          borderWidth: 1,
          borderRadius: 10,
        }
        ]
      }
    });

    const radarChartOptionSmall = computed(() => {
      return {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          r: {
            angleLines: {
              display: true
            },
            ticks: {
              stepSize: 5,
              color: 'rgba(255, 255, 255, 1)',
              backdropColor: '#19192E',
              font: {
                size: fontObj['small']
              },
            },
            pointLabels: {
              font: {
                size: fontObj['small']
              },
              color: 'white'
            }
          }
        },
        plugins: {
          legend: {
            display: false,
            align: 'end',
            labels: {
              usePointStyle: true,
              pointStyle: 'circle',
              color: 'white'
            }
          },
        },
      }
    });

    const radarChartOptionMedium = computed(() => {
      return {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          r: {
            angleLines: {
              display: true
            },
            ticks: {
              stepSize: 5,
              color: 'rgba(255, 255, 255, 1)',
              backdropColor: '#19192E',
              font: {
                size: fontObj['medium']
              },
            },
            pointLabels: {
              font: {
                size: fontObj['medium']
              },
              color: 'white'
            }
          }
        },
        plugins: {
          legend: {
            display: false,
            align: 'end',
            labels: {
              usePointStyle: true,
              pointStyle: 'circle',
              color: 'white'
            }
          },
        },
      }
    });

    const getKillData = computed(() => {
      return {
        chartType: 'kill',
        pointData: matchDump.value.kills_location,
        mapname: matchDump.value.mapname,
        premiumSub: isPremium.value
      }
    });

    const getDeathData = computed(() => {
      return {
        chartType: 'death',
        pointData: matchDump.value.deaths_location,
        mapname: matchDump.value.mapname,
        premiumSub: isPremium.value
      }
    });

    const getSnippetData = computed(() => {
      return {
        mapname: matchDump.value.mapname,
        premium: true,
        oldData: false,
        dsData: matchDump.value.deathsnaps,
        totalRounds: matchDump.value.totalrounds,
        snippet: matchDump.value.snippet
      }
    });

    return {
      matchDump,
      damageBarChart,
      damageBarChartOption,
      impactBarChart,
      impactBarChartOption,
      econChart,
      econChartOption,
      weaponChart,
      deathAgentChart,
      radarChartOptionSmall,
      radarChartOptionMedium,
      getKillData,
      getDeathData,
      getSnippetData,
      getOverview,
      currentTab,
      tabs,
      explanatoryKey,
      valmap,
      abilityIcon,
      isLoading,
      isPremium,
      isHidden
    }
  }
}
</script>